/**
 * Accepts and traverses a completed result from a query, looking for
 * periods that have a tilDatoInklusiv that is less than the fraDato.
 * If such a period is found, the tilDatoInklusiv is set to the fraDato.
 *
 * This is used for displaying periods in the frontend, where it is
 * possible to have a period where the end date is before the start date,
 * e.g. beskikkelser done by straksdeponering.
 * @param data
 * @returns transformed data
 */
export function transformQueryDataPerioder<T>(data: T) {
  if (!data) return data;
  let i = 0;
  const checkPerioder = (obj: any) => {
    i++;
    if (Array.isArray(obj)) {
      obj.forEach((o) => checkPerioder(o));
    } else if (typeof obj === "object") {
      if (obj?.periode) {
        if (obj.periode.tilDatoInklusiv < obj.periode.fraDato) {
          obj.periode.tilDatoInklusiv = obj.periode.fraDato;
        }
      }
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          checkPerioder(element);
        }
      }
    }
    i--;
    if (i === 0) {
      return data;
    }
  };
  return checkPerioder(data);
}
